import 'core-js/modules/es.object.assign.js';
import { jsx } from 'react/jsx-runtime';
import { Stack } from '@hub-la/design-system';

const EmptyState = () => {
  return jsx(Stack, Object.assign({
    flexDirection: "row",
    alignItems: "center",
    paddingX: 6,
    marginBottom: 1
  }, {
    children: jsx(Stack, Object.assign({
      width: "100%",
      marginRight: 4,
      paddingY: 3
    }, {
      children: "Sem video"
    }))
  }));
};

export { EmptyState };
